export default "__VITE_PUBLIC_ASSET__c366d4e0__"